import script from "./FileViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./FileViewer.vue?vue&type=script&setup=true&lang=js"

import "./FileViewer.vue?vue&type=style&index=0&id=72b538f4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72b538f4"]])

export default __exports__